import { EventBus } from '../../helpers';

type SingleBillPaymentMethodsEvents = {
  singleBillPaymentMethodCanBeUpdated: [canBeUpdated: boolean];
};

class SingleBillPaymentMethodsEventBus extends EventBus<SingleBillPaymentMethodsEvents> {}

export const singleBillPaymentMethodsEventBus = new SingleBillPaymentMethodsEventBus();
